import { render, staticRenderFns } from "./InventoryBuyerGroup.vue?vue&type=template&id=613be402&"
import script from "./InventoryBuyerGroup.vue?vue&type=script&lang=js&"
export * from "./InventoryBuyerGroup.vue?vue&type=script&lang=js&"
import style0 from "./InventoryBuyerGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports